import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import StickyTableContainer from "../ui/StickyTableContainer";

const SuivrDeEffect = () => {
    const [chains, setChains] = useState([]);
    const [selectedChain, setSelectedChain] = useState("");
    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState("");
    const [model, setModel] = useState(null);
    const [effectiveData, setEffectiveData] = useState({});
    const [effectiveRealData, setEffectiveRealData] = useState({});

    const trackingRows = Object.keys(effectiveData).sort().map((date) => {
        const realDirect = effectiveRealData[date]?.effectifDirects || 0;
        const plannedDirect = effectiveData[date]?.effectifDirects || 0;
        const realIndirect = effectiveRealData[date]?.effectifIndirects || 0;
        const plannedIndirect = effectiveData[date]?.effectifIndirects || 0;

        return {
            date,
            day: new Date(`${date}T00:00:00`).toLocaleDateString("fr-FR", { weekday: "long" }),
            realDirect,
            plannedDirect,
            directDifference: realDirect - plannedDirect,
            realIndirect,
            plannedIndirect,
            indirectDifference: realIndirect - plannedIndirect,
        };
    });

    useEffect(() => {
        const fetchChains = async () => {
            try {
                const response = await api.get("/chains");
                setChains(response.data);
            } catch (error) {
                console.error("Error fetching chains:", error);
            }
        };

        fetchChains();
    }, []);

    useEffect(() => {
        const fetchModelsByChain = async () => {
            if (selectedChain) {
                try {
                    const response = await api.get(`/models-by-chain/${selectedChain}`);
                    const chainModels = response.data || [];
                    const latestModel = chainModels[0] || null;
                    setModels(chainModels);
                    setSelectedModel(latestModel ? String(latestModel.id) : "");
                    setModel(latestModel);
                } catch (error) {
                    console.error("Error fetching models by chain:", error);
                    setModels([]);
                    setSelectedModel("");
                    setModel(null);
                }
            }
        };

        fetchModelsByChain();
    }, [selectedChain]);

    useEffect(() => {
        if (model && selectedChain) fetchEffectiveData(model.id);
    }, [model, selectedChain]);

    const handleSelectChange = (e) => {
        setSelectedChain(e.target.value);
        setModels([]);
        setSelectedModel("");
        setModel(null);
        setEffectiveData({});
        setEffectiveRealData({});
    };

    const handleModelChange = (e) => {
        const modelId = e.target.value;
        setSelectedModel(modelId);
        setModel(models.find((item) => String(item.id) === modelId) || null);
        setEffectiveData({});
        setEffectiveRealData({});
    };

    const fetchEffectiveData = async (modelId) => {
        try {
            // Fetch standard effective data for the selected chain
            const effectiveResponse = await api.get(`/effective_data_total/${modelId}/${selectedChain}`);
            const effectiveData = effectiveResponse.data;

            console.log(effectiveData)

            // Fetch real effective data for the selected chain
            const effectiveRealResponse = await api.get(`/effective_real_total/${modelId}/${selectedChain}`);
            const effectiveRealData = effectiveRealResponse.data;
            console.log(effectiveRealData)

            setEffectiveData(effectiveData);
            setEffectiveRealData(effectiveRealData);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="effective-tracking min-w-0 mt-5">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold leading-tight text-gray-900 sm:text-2xl">Suivi d'Effectif en nombre</h2>
                <div className="mb-4 flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
                    <select
                        className="block w-full mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                        value={selectedChain}
                        onChange={handleSelectChange}
                    >
                        <option value="">Choisir une chaîne</option>
                        {chains.map((chain) => (
                            <option key={chain.id} value={chain.id}>
                                {chain.name}
                            </option>
                        ))}
                    </select>
                    <select
                        className="block w-full mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                        value={selectedModel}
                        onChange={handleModelChange}
                        disabled={!selectedChain || models.length === 0}
                    >
                        <option value="">Choisir un modèle</option>
                        {models.map((item, index) => (
                            <option key={item.id} value={item.id}>
                                {item.modele}{index === 0 ? " — Plus récent" : ""}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {model && (
                <div className="mt-4 flex min-w-0 items-center gap-3 rounded-lg bg-slate-50 p-3 text-xs text-slate-700 sm:text-sm">
                    {model.image && <img
                        src={`https://api.crosscheckconf.net${model.image}`}
                        alt={model.name || model.modele}
                        className="h-12 w-12 shrink-0 rounded object-cover"
                    />}
                    <div className="min-w-0">
                        <p className="break-words"><strong>Modèle :</strong> {model.modele}</p>
                        <p className="break-words"><strong>Catégorie :</strong> {model.category}</p>
                    </div>
                </div>
            )}

            {model && effectiveData && effectiveRealData && (
                <>
                <div className="mt-4 w-full max-w-full overflow-hidden rounded border border-slate-300 md:hidden">
                    <table className="mobile-production-table w-full table-fixed border-collapse bg-white text-[7px] leading-[9px] text-slate-800">
                        <colgroup>
                            <col className="w-[17%]" />
                            <col className="w-[11%]" />
                            <col className="w-[12%]" />
                            <col className="w-[12%]" />
                            <col className="w-[12%]" />
                            <col className="w-[12%]" />
                            <col className="w-[12%]" />
                            <col className="w-[12%]" />
                        </colgroup>
                        <thead className="bg-slate-100 font-semibold text-slate-700">
                            <tr>
                                <th title="Date">Date</th>
                                <th title="Jour">Jour</th>
                                <th title="Effectif réel direct">Effectif<br />réel dir.</th>
                                <th title="Effectif prévisionnel direct">Effectif<br />prév. dir.</th>
                                <th title="Écart direct">Écart<br />direct</th>
                                <th title="Effectif réel indirect">Effectif<br />réel ind.</th>
                                <th title="Effectif prévisionnel indirect">Effectif<br />prév. ind.</th>
                                <th title="Écart indirect">Écart<br />indirect</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trackingRows.map((row) => (
                                <tr key={row.date}>
                                    <td className="font-semibold">{row.date.slice(5).replace("-", "/")}</td>
                                    <td className="capitalize">{row.day.slice(0, 3)}</td>
                                    <td>{row.realDirect}</td>
                                    <td>{row.plannedDirect}</td>
                                    <td className={row.directDifference < 0 ? "font-bold text-red-700" : "font-semibold"}>{row.directDifference}</td>
                                    <td>{row.realIndirect}</td>
                                    <td>{row.plannedIndirect}</td>
                                    <td className={row.indirectDifference < 0 ? "font-bold text-red-700" : "font-semibold"}>{row.indirectDifference}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="hidden md:block">
                <StickyTableContainer className="mt-5">
                    <table className="dashboard-sticky-table table-auto w-full min-w-[1000px] bg-slate-200 border-collapse border border-gray-300 shadow-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="sticky left-0 z-20 bg-gray-100 px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Date</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Jour</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Effectif Réel direct</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Effectif Prévisionnel direct</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Ecart Direct</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Effectif Réel indirect</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Effectif Prévisionnel indirect</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Ecart Indirect</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trackingRows.map((row) => {
                                return (
                                    <tr key={row.date}>
                                        <td className="sticky left-0 z-10 bg-slate-200 p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.date}</td>
                                        <td className="p-[2rem] text-left capitalize text-[#4E4A4A] font-semibold border border-gray-300">{row.day}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.realDirect}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.plannedDirect}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.directDifference}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.realIndirect}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.plannedIndirect}</td>
                                        <td className="p-[2rem] text-left text-[#4E4A4A] font-semibold border border-gray-300">{row.indirectDifference}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </StickyTableContainer>
                </div>
                </>
            )}
        </div>
    );
};

export default SuivrDeEffect;
